import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { useLegacySearchTheme } from '@atlassian/navigation-system/experimental/use-legacy-search-theme';
import {
	ProductSearchInputSkeletonInteractive,
	ProductSearchInputSkeleton,
} from '@atlassian/product-search-dialog/skeleton';

import { useTheme as useThemeDI } from '../../../controllers/theme/main.tsx';
import type { UseThemeType } from '../../../controllers/theme/types.tsx';

type Props = {
	useTheme?: UseThemeType;
	placeholder?: string;
	ariaLabel?: string;
};

export const SkeletonInteractive = ({ useTheme = useThemeDI, placeholder, ariaLabel }: Props) => {
	/**
	 * The nav3 custom theme object
	 */
	const theme = useTheme();
	/**
	 * A nav4 search theme that works with the nav3 theming API
	 */
	const newTheme = useLegacySearchTheme();

	if (__SERVER__) {
		return (
			<ProductSearchInputSkeleton
				shouldFillContainer={getWillShowNav4()}
				theme={getWillShowNav4() ? newTheme : theme && theme.mode && theme.mode.search}
				placeholder={placeholder}
				ariaLabel={ariaLabel}
				dataSsrPlaceholder={
					fg('qs-7058-remove-experiment-call-search-dialog') ? 'nav4-search-bar' : undefined
				}
			/>
		);
	}
	return (
		<ProductSearchInputSkeletonInteractive
			shouldFillContainer={getWillShowNav4()}
			theme={getWillShowNav4() ? newTheme : theme && theme.mode && theme.mode.search}
			placeholder={placeholder || ''}
			stickySearchEnabled
		/>
	);
};
